<template>
  <div class="segmented-tabs" role="group" :aria-label="ariaLabel">
    <template v-for="(opt, index) in options">
      <span
        v-if="showDivider(index)"
        :key="`sep-${index}`"
        class="segmented-tabs__separator"
        aria-hidden="true"
      />
      <button
        :key="`opt-${opt.value}`"
        type="button"
        class="segmented-tabs__item"
        :class="{
          'segmented-tabs__item--active': opt.value === value,
          'segmented-tabs__item--disabled': opt.disabled
        }"
        :aria-pressed="opt.value === value ? 'true' : 'false'"
        :disabled="opt.disabled"
        @click="select(opt)"
      >
        {{ opt.text }}
      </button>
    </template>
  </div>
</template>

<script>
export default {
  name: 'SegmentedTabs',
  props: {
    // currently selected value (v-model)
    value: {
      type: [String, Number],
      required: true
    },
    // [{ text, value, disabled? }]
    options: {
      type: Array,
      required: true
    },
    // accessible name for the button group, announced by screen readers
    ariaLabel: {
      type: String,
      default: null
    }
  },
  methods: {
    select (opt) {
      if (opt.disabled || opt.value === this.value) return
      this.$emit('input', opt.value)
    },
    // a divider is shown between two adjacent items only when neither of
    // them is the active (raised) pill
    showDivider (index) {
      if (index === 0) return false
      const prev = this.options[index - 1]
      const curr = this.options[index]
      return prev.value !== this.value && curr.value !== this.value
    }
  }
}
</script>

<style lang="scss" scoped>
.segmented-tabs {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  padding: 4px 8px;
  background-color: $nl-surface-subtle;
  border-radius: 8px;
  overflow: hidden;

  &__item {
    flex: 1 0 0;
    min-width: 0;
    height: 100%;
    padding: 3px 10px;
    border: 0;
    background: transparent;
    border-radius: 4px;
    font-family: 'Source Sans Pro';
    font-size: 14px;
    line-height: 22.4px;
    color: $nl-text-muted;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    transition: color 0.15s ease, background-color 0.15s ease;

    &--active {
      background-color: $nl-surface;
      color: $nl-text-strong;
      font-weight: 600;
      box-shadow: $nl-tab-shadow;
    }

    &--disabled {
      cursor: not-allowed;
    }
  }

  @media screen and (min-width: 394px) {
    &__item {
      font-size: 16px;
      line-height: 22.4px;
    }
  }

  &__separator {
    flex: 0 0 1px;
    width: 1px;
    height: 100%;
    background-color: #8e8e93;
    opacity: 0.3;
    border-radius: 0.5px;
  }
}
</style>
